module.exports = __webpack_public_path__ + "img/icons BFr_7.36a36cc2.png";